import * as Yup from 'yup';

export const forgotPasswordSchema = Yup.object().shape({
    recoveryOptions: Yup.string().required('Select Recovery Option'),
  
    username: Yup.string().when('recoveryOptions', {
      is: 'userName',
      then: (schema) =>
        schema
          .min(2, 'Too Short!')
          .max(50, 'Too Long!')
          .required('Enter your Username'),
      otherwise: (schema) =>
        schema.required('Select a Username'),  
    }),
  
    email: Yup.string().when('recoveryOptions', {
      is: 'email',
      then: (schema) => schema.email('Invalid email').required('Enter your Email'),
      otherwise: (schema) => schema.notRequired(),
    }),
  
    phoneOptions: Yup.string().required('Select Phone Option'),
  });
   